import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { Form } from "react-bootstrap";

const COLORS = ["#ff7675", "#40FF56"];

const AttendancePane = ({
  presenceLogs,
  groups,
  selectedGroupForAttendance,
  setSelectedGroupForAttendance,
  isModal = false,
}) => {
  const attendanceData = useMemo(() => {
    let totalMissing = 0;
    let totalPresent = 0;
    const now = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(now.getMonth() - 1);

    presenceLogs.forEach((log) => {
      const logTime = log.logTime?.toDate();
      if (logTime && logTime >= oneMonthAgo) {
        if (
          selectedGroupForAttendance === "all" ||
          log.groupID === selectedGroupForAttendance
        ) {
          totalMissing += log.totalmissingStudents || 0;
          totalPresent += log.totalPresentStudents || 0;
        }
      }
    });

    return [
      { name: "חיסורים", value: totalMissing },
      { name: "נוכחויות", value: totalPresent },
    ];
  }, [presenceLogs, selectedGroupForAttendance]);

  const hasData = attendanceData.some((item) => item.value > 0);

  return (
    <div
      style={{
        direction: "rtl",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Form.Select
        value={selectedGroupForAttendance}
        onChange={(e) => setSelectedGroupForAttendance(e.target.value)}
        style={{
          maxWidth: "300px",
          margin: "0",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "6px 12px",
          paddingRight: "40px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          cursor: "pointer",
          transition: "all 0.2s ease",
          textAlign: "right",
          direction: "rtl",
          appearance: "none",
          backgroundImage:
            "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left 0.75rem center",
          backgroundSize: "16px 12px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: isModal ? "18px" : "12px",
        }}
      >
        <option value="all">כל הקבוצות</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>
            {group.name}, סניף {group.dojo}
          </option>
        ))}
      </Form.Select>

      {!hasData ? (
        <div
          style={{
            height: isModal ? "400px" : "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#636e72",
            fontSize: isModal ? "1.2em" : "0.9em",
            textAlign: "center",
            padding: "20px",
          }}
        >
          אין נתוני נוכחות זמינים{" "}
          {selectedGroupForAttendance !== "all" ? `לקבוצה` : ""}
        </div>
      ) : (
        <div style={{ flex: 1, minHeight: 0 }}>
          <ResponsiveContainer width="100%" height={isModal ? 400 : 130}>
            <PieChart>
              <Pie
                data={attendanceData}
                cx="50%"
                cy="50%"
                innerRadius={isModal ? 20 : 15}
                outerRadius={isModal ? 120 : 40}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="value"
                labelLine={false}
                label={({
                  cx,
                  cy,
                  midAngle,
                  innerRadius,
                  outerRadius,
                  value,
                }) => {
                  const RADIAN = Math.PI / 180;
                  const radius =
                    innerRadius + (outerRadius - innerRadius) * 0.5;
                  const x = cx + radius * Math.cos(-midAngle * RADIAN);
                  const y = cy + radius * Math.sin(-midAngle * RADIAN);

                  return (
                    <text
                      x={x}
                      y={y}
                      fill="white"
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontSize={isModal ? 14 : 11}
                      fontWeight="bold"
                    >
                      {value}
                    </text>
                  );
                }}
              >
                {attendanceData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  fontSize: isModal ? "14px" : "12px",
                }}
              />
              <Legend
                iconSize={isModal ? 10 : 8}
                layout="horizontal"
                verticalAlign="bottom"
                align="center"
                fontSize={isModal ? "14px" : "11px"}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default React.memo(AttendancePane);
